"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "control-wrapper" };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { class: "panel-button-area" };
var _hoisted_4 = { class: "control-item-detail-row" };
var _hoisted_5 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_6 = ["value"];
var _hoisted_7 = { key: 0 };
var _hoisted_8 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", {
    value: "480p",
    selected: ""
}, " 480p ", -1);
var _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", {
    value: "720p",
    selected: ""
}, " 720p ", -1);
var _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("option", {
    value: "1080p",
    selected: ""
}, " 1080p ", -1);
var _hoisted_12 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_13 = ["value"];
var _hoisted_14 = {
    key: 1,
    class: "panel-hangup"
};
var index_1 = require("../index");
var vue_3 = require("vue");
var ControlPanelItem_vue_1 = require("./ControlPanelItem.vue");
var store_1 = require("../store");
var constants_1 = require("../constants");
var reject_vue_1 = require("../icons/reject.vue");
var acceptAudio_vue_1 = require("../icons/acceptAudio.vue");
var acceptVideo_vue_1 = require("../icons/acceptVideo.vue");
var add_vue_1 = require("../icons/add.vue");
var camera_vue_1 = require("../icons/camera.vue");
var microphone_vue_1 = require("../icons/microphone.vue");
var switch_vue_1 = require("../icons/switch.vue");
// import hangupSVG from '../assets/hangup.vue';
var hangup_vue_1 = require("../icons/hangup.vue");
var microphoneClosedBig_vue_1 = require("../icons/microphoneClosedBig.vue");
var cameraClosedBig_vue_1 = require("../icons/cameraClosedBig.vue");
var utils_1 = require("../utils");
require("../style.css");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ControlPanel',
    setup: function (__props) {
        var _this = this;
        var cameraList = (0, vue_3.ref)([]);
        var microphoneList = (0, vue_3.ref)([]);
        var currentCamera = (0, vue_3.ref)("");
        var currentMicrophone = (0, vue_3.ref)("");
        var currentVideoQuality = (0, vue_3.ref)("");
        var openCameraDetail = (0, vue_3.ref)(false);
        var openMicrophoneDetail = (0, vue_3.ref)(false);
        var freshDeviceList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = cameraList;
                        return [4 /*yield*/, index_1.TUICallKitServer.getDeviceList('camera')];
                    case 1:
                        _a.value = _c.sent();
                        _b = microphoneList;
                        return [4 /*yield*/, index_1.TUICallKitServer.getDeviceList('microphones')];
                    case 2:
                        _b.value = _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        (0, vue_3.onMounted)(function () {
            freshDeviceList();
            document.documentElement.addEventListener('click', function (e) {
                openCameraDetail.value = false;
                openMicrophoneDetail.value = false;
            });
        });
        var hangup = function () {
            index_1.TUICallKitServer.hangup();
        };
        function switchCameraDevice() {
            index_1.TUICallKitServer.switchDevice("video", currentCamera.value);
            openCameraDetail.value = false;
        }
        var switchMicrophoneDevice = function () {
            index_1.TUICallKitServer.switchDevice('audio', currentMicrophone.value);
            openMicrophoneDetail.value = false;
        };
        var toggleCamera = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = store_1.profile.value) === null || _a === void 0 ? void 0 : _a.camera)) return [3 /*break*/, 2];
                        return [4 /*yield*/, index_1.TUICallKitServer.closeCamera()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, index_1.TUICallKitServer.openCamera()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var toggleMicrophone = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = store_1.profile.value) === null || _a === void 0 ? void 0 : _a.microphone)) return [3 /*break*/, 2];
                        return [4 /*yield*/, index_1.TUICallKitServer.closeMicrophone()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, index_1.TUICallKitServer.openMicrophone()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var setVideoQuality = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.TUICallKitServer.setVideoQuality(currentVideoQuality.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var switchCallMediaType = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.TUICallKitServer.switchCallMediaType()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        function addPerson_debug() {
            (0, store_1.changeRemoteList)(__spreadArray(__spreadArray([], store_1.remoteList.value, true), [{
                    userID: "qerTest".concat(store_1.remoteList.value.length),
                    isEntered: false,
                    microphone: true,
                    camera: true,
                }], false));
        }
        function accept() {
            index_1.TUICallKitServer.accept();
        }
        function reject() {
            index_1.TUICallKitServer.reject();
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(utils_1.isMobile) && (0, vue_2.unref)(store_1.status) !== (0, vue_2.unref)(constants_1.STATUS).CALLING_C2C_AUDIO)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.dialingInfo)), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).BE_INVITED)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                            (0, vue_2.createVNode)(ControlPanelItem_vue_1.default, {
                                action: reject,
                                isMobile: (0, vue_2.unref)(utils_1.isMobile),
                                size: (0, vue_2.unref)(utils_1.isMobile) ? 'medium' : 'small'
                            }, {
                                text: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('reject')), 1)
                                ]; }),
                                icon: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(reject_vue_1.default)
                                ]; }),
                                _: 1
                            }, 8, ["isMobile", "size"]),
                            (0, vue_2.createVNode)(ControlPanelItem_vue_1.default, {
                                action: accept,
                                isMobile: (0, vue_2.unref)(utils_1.isMobile),
                                size: (0, vue_2.unref)(utils_1.isMobile) ? 'medium' : 'small'
                            }, {
                                text: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('accept')), 1)
                                ]; }),
                                icon: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.unref)(store_1.callType) === (0, vue_2.unref)(constants_1.CALL_TYPE_STRING).AUDIO)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(acceptAudio_vue_1.default, { key: 0 }))
                                        : ((0, vue_2.unref)(store_1.callType) === (0, vue_2.unref)(constants_1.CALL_TYPE_STRING).VIDEO)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(acceptVideo_vue_1.default, { key: 1 }))
                                            : (0, vue_2.createCommentVNode)("", true)
                                ]; }),
                                _: 1
                            }, 8, ["isMobile", "size"])
                        ], 64))
                        : ((0, vue_2.unref)(store_1.status) !== 'idle')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                ((0, vue_2.unref)(store_1.callType) === (0, vue_2.unref)(constants_1.CALL_TYPE_STRING).VIDEO)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ControlPanelItem_vue_1.default, {
                                        key: 0,
                                        action: toggleCamera,
                                        hasDetail: !(0, vue_2.unref)(utils_1.isMobile),
                                        isMobile: (0, vue_2.unref)(utils_1.isMobile),
                                        size: (0, vue_2.unref)(utils_1.isMobile) ? 'medium' : 'small'
                                    }, {
                                        text: (0, vue_2.withCtx)(function () {
                                            var _a;
                                            return [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(((_a = (0, vue_2.unref)(store_1.profile)) === null || _a === void 0 ? void 0 : _a.camera) ? (0, vue_2.unref)(store_1.t)('camera-opened') : (0, vue_2.unref)(store_1.t)('camera-closed')), 1)
                                            ];
                                        }),
                                        icon: (0, vue_2.withCtx)(function () {
                                            var _a, _b;
                                            return [
                                                ((_a = (0, vue_2.unref)(store_1.profile)) === null || _a === void 0 ? void 0 : _a.camera)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(camera_vue_1.default, { key: 0 }))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (!((_b = (0, vue_2.unref)(store_1.profile)) === null || _b === void 0 ? void 0 : _b.camera))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(cameraClosedBig_vue_1.default, { key: 1 }))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ];
                                        }),
                                        detail: (0, vue_2.withCtx)(function () {
                                            var _a;
                                            return [
                                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('camera')), 1),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        class: "device-select",
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((currentCamera).value = $event); }),
                                                        onChange: switchCameraDevice
                                                    }, [
                                                        (0, vue_2.createElementVNode)("option", _hoisted_5, (0, vue_2.toDisplayString)(cameraList.value && ((_a = cameraList.value[0]) === null || _a === void 0 ? void 0 : _a.label)), 1),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(cameraList.value, function (camera) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                value: camera.deviceId,
                                                                key: camera.deviceId
                                                            }, (0, vue_2.toDisplayString)(camera.label), 9, _hoisted_6));
                                                        }), 128))
                                                    ], 544), [
                                                        [vue_2.vModelSelect, currentCamera.value]
                                                    ])
                                                ]),
                                                ((0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).DIALING_C2C)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('image-resolution')), 1),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                            class: "device-select",
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((currentVideoQuality).value = $event); }),
                                                            onChange: setVideoQuality
                                                        }, [
                                                            (0, vue_2.createElementVNode)("option", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('default-image-resolution')), 1),
                                                            _hoisted_9,
                                                            _hoisted_10,
                                                            _hoisted_11
                                                        ], 544), [
                                                            [vue_2.vModelSelect, currentVideoQuality.value]
                                                        ])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ];
                                        }),
                                        _: 1
                                    }, 8, ["hasDetail", "isMobile", "size"]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createVNode)(ControlPanelItem_vue_1.default, {
                                    action: toggleMicrophone,
                                    hasDetail: !(0, vue_2.unref)(utils_1.isMobile),
                                    isMobile: (0, vue_2.unref)(utils_1.isMobile),
                                    size: (0, vue_2.unref)(utils_1.isMobile) ? 'medium' : 'small'
                                }, {
                                    text: (0, vue_2.withCtx)(function () {
                                        var _a;
                                        return [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(((_a = (0, vue_2.unref)(store_1.profile)) === null || _a === void 0 ? void 0 : _a.microphone) ? (0, vue_2.unref)(store_1.t)('microphone-opened') : (0, vue_2.unref)(store_1.t)('microphone-closed')), 1)
                                        ];
                                    }),
                                    icon: (0, vue_2.withCtx)(function () {
                                        var _a, _b;
                                        return [
                                            ((_a = (0, vue_2.unref)(store_1.profile)) === null || _a === void 0 ? void 0 : _a.microphone)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(microphone_vue_1.default, { key: 0 }))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (!((_b = (0, vue_2.unref)(store_1.profile)) === null || _b === void 0 ? void 0 : _b.microphone))
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(microphoneClosedBig_vue_1.default, { key: 1 }))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ];
                                    }),
                                    detail: (0, vue_2.withCtx)(function () {
                                        var _a;
                                        return [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('microphone')) + " ", 1),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    class: "device-select",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((currentMicrophone).value = $event); }),
                                                    onChange: switchMicrophoneDevice
                                                }, [
                                                    (0, vue_2.createElementVNode)("option", _hoisted_12, (0, vue_2.toDisplayString)(microphoneList.value && ((_a = microphoneList.value[0]) === null || _a === void 0 ? void 0 : _a.label)), 1),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(microphoneList.value, function (microphone) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            value: microphone.deviceId,
                                                            key: microphone.deviceId
                                                        }, (0, vue_2.toDisplayString)(microphone.label), 9, _hoisted_13));
                                                    }), 128))
                                                ], 544), [
                                                    [vue_2.vModelSelect, currentMicrophone.value]
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["hasDetail", "isMobile", "size"]),
                                false
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ControlPanelItem_vue_1.default, {
                                        key: 1,
                                        action: addPerson_debug
                                    }, {
                                        text: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('invited-person')), 1)
                                        ]; }),
                                        icon: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(add_vue_1.default)
                                        ]; }),
                                        _: 1
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(store_1.status) === 'calling-c2c-video')
                                    ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ControlPanelItem_vue_1.default, {
                                        key: 2,
                                        action: switchCallMediaType
                                    }, {
                                        text: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.t)('video-to-audio')), 1)
                                        ]; }),
                                        icon: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(switch_vue_1.default)
                                        ]; }),
                                        _: 1
                                    }, 512)), [
                                        [vue_2.vShow, !(0, vue_2.unref)(utils_1.isMobile)]
                                    ])
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.withDirectives)((0, vue_2.createVNode)(ControlPanelItem_vue_1.default, { action: hangup }, {
                                    text: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(utils_1.isMobile) ? '' : (0, vue_2.unref)(store_1.t)('hangup')), 1)
                                    ]; }),
                                    icon: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(hangup_vue_1.default)
                                    ]; }),
                                    _: 1
                                }, 512), [
                                    [vue_2.vShow, !(0, vue_2.unref)(utils_1.isMobile)]
                                ])
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true)
                ]),
                ((0, vue_2.unref)(store_1.status) !== (0, vue_2.unref)(constants_1.STATUS).IDLE && (0, vue_2.unref)(store_1.status) !== (0, vue_2.unref)(constants_1.STATUS).BE_INVITED)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(ControlPanelItem_vue_1.default, {
                            action: hangup,
                            size: (0, vue_2.unref)(utils_1.isMobile) ? 'large' : 'small'
                        }, {
                            text: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(utils_1.isMobile) ? '' : (0, vue_2.unref)(store_1.t)('hangup')), 1)
                            ]; }),
                            icon: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(hangup_vue_1.default)
                            ]; }),
                            _: 1
                        }, 8, ["size"]), [
                            [vue_2.vShow, (0, vue_2.unref)(utils_1.isMobile)]
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
